import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { RegisterService } from "../services/register.service";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "../environments/environment";
import {CommonModule} from "@angular/common";

@Component({
  selector: "app-error",
  templateUrl: "./error.component.html",
  standalone: true,
  imports: [CommonModule]
})
export class ErrorComponent implements OnInit {
  private page = "";
  private countryCode = "de";
  newsletterImage = "";
  stickImage = "";
  deButton = "";
  amcLogoImage = "";
  fieldLabel;
  fieldLabel2;
  amcUnsubFormLabel: FormGroup;
  translateData = [];
  language = { key: ["de"] };

  errorMessage: string;
  errorMessageList: string[];
  found: boolean;
  href = "/amc-forms-web/";

  constructor(
    private formBuilder: FormBuilder,
    private registerService: RegisterService,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private _platformId: Object
  ) {
    this.newsletterImage = environment.newsletterImage;
    this.errorMessageList = ["email", "nms", "error", "invalidlink"];
  }

  ngOnInit() {
    // get language param from route
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.countryCode = params.get("lang").toLowerCase();
    });

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.errorMessage = params.get("message").toLowerCase();
    });

    if (this.countryCode == null) {
      this.countryCode = "de";
    }
    //email nms error invalidlink
    let found = this.errorMessageList.filter((e) => e === this.errorMessage);

    if (this.errorMessage == null || !found.length) {
      this.errorMessage = "unknown";
    }

    this.loadTranslateDataFromDB(this.countryCode);

    /**
     * Definition of form field-labels for frontend
     */
    this.amcUnsubFormLabel = this.formBuilder.group({
      nl_heading: ["AMC News"],
      nl_warning_mail_exists: [
        "Diese Email-Adresse ist bereits für den Newsletter angemeldet.",
      ],
      nl_warning_mail_not_sent: [
        "Aufgrund eines Fehlers konnte keine Email verschickt werden. Bitte versuchen Sie es erneut.",
      ],
      nl_warning_invalid: [
        "Der Link ist nicht mehr gültig. Bitte melden Sie sich erneut an.",
      ],
      nl_warning: [
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Kundendienst.",
      ],
      nl_service_nr: ["+49 (0) 6721-180 01"],
      nl_service_time: ["Mo. bis Fr. 8:00 - 17:00"],
      nl_back_btn: ["Zurück"],
    });
  }

  getFieldLabel(Label) {
    this.fieldLabel2 = this.amcUnsubFormLabel.get(Label);
    return this.fieldLabel2 != null ? this.fieldLabel2.value : "";
  }

  getErrorMessage() {
    return this.errorMessage;
  }

  getHref() {
    return this.href + this.countryCode + "/newsletter";
  }

  /**
   * Get translated data from the database from register.service.ts
   * @param language
   */
  loadTranslateDataFromDB(language) {
    this.translateData = [];
    this.language.key = language;
    this.registerService.loadTranslateDataFromDB(this.language.key).subscribe(
      (data) => {
        this.translateData = data;
        this.setTranslate();
      },
      (error) => {
        this.errorMessage = "error";
      }
    );
  }

  /**
   * Set labels with translated texts from the database
   */
  setTranslate() {
    this.translateData.forEach((obj) => {
      this.fieldLabel = this.translateData.find((k) => k.key === obj.key);
      if (
        this.fieldLabel != null &&
        this.amcUnsubFormLabel.get(obj.key) != null
      ) {
        this.amcUnsubFormLabel.controls[obj.key].setValue(this.fieldLabel.text);
      }
    });
  }
}
